import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CHANGE_PASSWORD } from '../../graphql/passwords';
import { showInfoNotification } from '../../actions/notifications';
import { createOnErrorHandler } from '../errors/Errors';
import ChangePasswordPopup from '../popups/ChangePasswordPopup';
import { getDaysToPasswordExpiration } from '../../reducers';
import {
    isPasswordExpirationNonnegligible,
    isPasswordExpirationCritical,
} from '../../utils/authentication';
import { resetDaysToPasswordExpiration } from '../../actions/authentication';

function ChangePasswordButton() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const apolloClient = useApolloClient();
    const [isPopupVisible, setPopupVisible] = useState(false);
    const daysToPasswordExpiration = useSelector(getDaysToPasswordExpiration);
    const onMutationCompletedHandler = () => {
        setPopupVisible(false);
        dispatch(resetDaysToPasswordExpiration());
        dispatch(showInfoNotification(t('change-password.notification.change-password-success')));
    };
    const onMutationErrorHandler = createOnErrorHandler(dispatch, apolloClient, t('change-password.notification.change-password-failure'));
    const [mutationCallback] = useMutation(CHANGE_PASSWORD, { onCompleted: onMutationCompletedHandler, onError: onMutationErrorHandler });
    const onSubmitHandler = (oldPassword, newPassword, repeatPassword) => mutationCallback({ variables: { o: oldPassword, n: newPassword, r: repeatPassword } });
    const onClickHandler = () => setPopupVisible(true);
    const onCancelHandler = () => setPopupVisible(false);
    const showPasswordExpirationWarning = isPasswordExpirationNonnegligible(daysToPasswordExpiration);
    const showPasswordExpirationError = isPasswordExpirationCritical(daysToPasswordExpiration);
    let expirationTitle;
    if (daysToPasswordExpiration === null) {
        expirationTitle = t('left-menu.change-password-no-expiration');
    } else if (daysToPasswordExpiration === 0) {
        expirationTitle = t('left-menu.change-password-expiration-in-24-hours');
    } else {
        expirationTitle = t('left-menu.change-password', { expireInDays: daysToPasswordExpiration });
    }
    return (
        <>
            <button
                type="button"
                className={`change-password-button${showPasswordExpirationWarning ? ' warning' : ''}${showPasswordExpirationError ? ' error' : ''}`}
                onClick={onClickHandler}
                title={expirationTitle}
                aria-label={expirationTitle}
            >
                <FontAwesomeIcon icon="key" />
            </button>
            {isPopupVisible && <ChangePasswordPopup onConfirm={onSubmitHandler} onCancel={onCancelHandler} />}
        </>
    );
}

export default ChangePasswordButton;
